<template>
    <el-dialog
        :title="dialogTitle"
        :visible.sync="invoiceDetailsDialog"
        width="800px"
        :before-close="handleDialogClose"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :modal-append-to-body="false"
        custom-class="custom-form-dialog custom_invoice_detail_dialog"
    >
        <div>
            <div class="page_little_title">订单信息</div>
            <el-form label-position="top" size="small">
                <el-row :gutter="24" style="flex-wrap: wrap" type="flex">
                    <el-col :span="12">
                        <el-form-item label="关联订单">
                            <div>
                                <el-link
                                    type="primary"
                                    v-text="invoiceDetails.order_info.order_no"
                                    :underline="false"
                                    @click="handleClickOrderDetail"
                                >
                                </el-link>
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="客户联系人">
                            <div
                                v-text="
                                    invoiceDetails.order_info.contact_info &&
                                    invoiceDetails.order_info.contact_info.name
                                "
                            ></div>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div class="page_little_title">订单金额信息</div>
            <el-form label-position="top" size="small">
                <el-row :gutter="24" style="flex-wrap: wrap" type="flex">
                    <el-col :span="12">
                        <el-form-item label="订单总金额">
                            <div v-text="invoiceDetails.order_info.total_price"></div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="已回款金额">
                            <div v-text="invoiceDetails.order_info.total_repay_price"></div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="待回款金额">
                            <div v-text="invoiceDetails.order_info.no_repay_price"></div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="实际回款金额">
                            <div v-text="invoiceDetails.order_info.repay_price"></div>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div class="page_little_title">开票申请信息</div>
            <el-form label-position="top" size="small">
                <el-row :gutter="24" style="flex-wrap: wrap" type="flex">
                    <el-col :span="12">
                        <el-form-item label="开票公司">
                            <div v-text="invoiceDetails.invoice_info.invoice_company_name"></div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="发票类型">
                            <div v-text="invoiceDetails.invoice_info.invoice_type_name"></div>
                        </el-form-item>
                    </el-col>
                    <el-col
                        v-if="
                            invoiceDetails.invoice_info.invoice_type === 1 ||
                            invoiceDetails.invoice_info.invoice_type === 2
                        "
                        :span="12"
                    >
                        <el-form-item label="电子发票提供方式">
                            <div v-text="invoiceDetails.invoice_info.invoice_method_name || '--'"></div>
                        </el-form-item>
                    </el-col>
                    <el-col
                        v-if="
                            invoiceDetails.invoice_info.invoice_type === 1 ||
                            invoiceDetails.invoice_info.invoice_type === 2
                        "
                        :span="12"
                    >
                        <el-form-item label="电子收票邮箱">
                            <div v-text="invoiceDetails.invoice_info.invoice_email || '--'"></div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="本次开票金额">
                            <div v-text="invoiceDetails.invoice_info.invoice_amount"></div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="开票对象">
                            <div v-text="invoiceDetails.invoice_info.invoice_title_type_name"></div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="18">
                        <el-form-item label="开票信息">
                            <div class="text_bg" v-html="invoiceDetails.invoice_info.invoice_info"></div>
                        </el-form-item>
                    </el-col>
                    <el-col
                        v-if="
                            invoiceDetails.invoice_info.invoice_type === 3 ||
                            invoiceDetails.invoice_info.invoice_type === 4
                        "
                        :span="12"
                    >
                        <el-form-item label="收货人" prop="receive_name">
                            <span
                                v-text="
                                    invoiceDetails.invoice_info.receive_name
                                        ? invoiceDetails.invoice_info.receive_name
                                        : '--'
                                "
                            ></span>
                        </el-form-item>
                    </el-col>
                    <el-col
                        v-if="
                            invoiceDetails.invoice_info.invoice_type === 3 ||
                            invoiceDetails.invoice_info.invoice_type === 4
                        "
                        :span="12"
                    >
                        <el-form-item label="收货人电话" prop="receive_phone">
                            <span
                                v-text="
                                    invoiceDetails.invoice_info.receive_phone
                                        ? invoiceDetails.invoice_info.receive_phone
                                        : '--'
                                "
                            ></span>
                        </el-form-item>
                    </el-col>
                    <el-col
                        v-if="
                            invoiceDetails.invoice_info.invoice_type === 3 ||
                            invoiceDetails.invoice_info.invoice_type === 4
                        "
                        :span="24"
                    >
                        <el-form-item label="收货地址" prop="receive_addr">
                            <span
                                v-text="
                                    invoiceDetails.invoice_info.receive_addr
                                        ? invoiceDetails.invoice_info.receive_addr
                                        : '--'
                                "
                            ></span>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="24">
                    <el-col :span="12">
                        <el-form-item label="备注">
                            <div class="text_bg" v-text="invoiceDetails.invoice_info.remark"></div>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="24">
                    <el-col :span="24">
                        <el-form-item label="附件">
                            <div
                                class="file_upload_wrap"
                                v-if="
                                    invoiceDetails.invoice_info.attachments &&
                                    invoiceDetails.invoice_info.attachments.length
                                "
                            >
                                <ul class="upload_file_list upload_file_list_detail">
                                    <li
                                        v-for="file in invoiceDetails.invoice_info.attachments"
                                        class="upload_file_item"
                                    >
                                        <div class="file_left_wrap">
                                            <img
                                                alt=""
                                                class="file_img"
                                                src="https://download.hecoos.com/enlightv/2023-37/chyZ4zyQiQkR5byRwSCT.png"
                                            />
                                            <div class="file_info_wrap">
                                                <p class="file_name" v-text="file.file_name"></p>
                                                <p class="file_size" v-text="file.file_size"></p>
                                            </div>
                                        </div>
                                        <div class="file_right_wrap">
                                            <el-tooltip content="预览" effect="dark" placement="top">
                                                <span class="handle_icon_wrap" @click="handleClickPreview(file)">
                                                    <i class="iconfont icon-yanjing"></i>
                                                </span>
                                            </el-tooltip>
                                            <span class="line"></span>
                                            <el-tooltip content="下载" effect="dark" placement="top">
                                                <span class="handle_icon_wrap" @click="handleClickDownloadFile(file)">
                                                    <i class="iconfont icon-daochu"></i>
                                                </span>
                                            </el-tooltip>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <template v-if="status == 2">
                <div class="page_little_title">确认开票信息</div>
                <el-form label-position="top" size="small">
                    <el-row :gutter="24" style="flex-wrap: wrap" type="flex">
                        <el-col :span="12">
                            <el-form-item label="发票号码">
                                <el-input
                                    v-if="isEditNumber"
                                    v-model="invoiceDetails.invoice_info.invoice_number"
                                    @blur="handleBlur"
                                ></el-input>
                                <div v-else @click="handleClickRowEdit('isEditNumber')" v-text="invoiceDetails.invoice_info.invoice_number"></div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="已开票金额">
                                <div v-text="invoiceDetails.invoice_info.invoice_amount"></div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <div class="page_little_title">其他信息</div>
                <el-form label-position="top" size="small">
                    <el-row :gutter="24">
                        <el-col :span="12">
                            <el-form-item label="财务备注">
                                <el-input
                                    v-if="isEditRemark"
                                    v-model="invoiceDetails.invoice_info.finance_remark"
                                    @blur="handleBlur"
                                ></el-input>
                                <div class="text_bg" v-else @click="handleClickRowEdit('isEditRemark')" v-text="invoiceDetails.invoice_info.finance_remark"></div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="24">
                            <el-form-item label="附件">
                                <div
                                    class="file_upload_wrap"
                                    v-if="
                                        invoiceDetails.invoice_info.finance_attachments &&
                                        invoiceDetails.invoice_info.finance_attachments.length
                                    "
                                >
                                    <ul class="upload_file_list upload_file_list_detail">
                                        <li
                                            v-for="file in invoiceDetails.invoice_info.finance_attachments"
                                            class="upload_file_item"
                                        >
                                            <div class="file_left_wrap">
                                                <img
                                                    alt=""
                                                    class="file_img"
                                                    src="https://download.hecoos.com/enlightv/2023-37/chyZ4zyQiQkR5byRwSCT.png"
                                                />
                                                <div class="file_info_wrap">
                                                    <p class="file_name" v-text="file.file_name"></p>
                                                    <p class="file_size" v-text="file.file_size"></p>
                                                </div>
                                            </div>
                                            <div class="file_right_wrap">
                                                <el-tooltip content="预览" effect="dark" placement="top">
                                                    <span class="handle_icon_wrap" @click="handleClickPreview(file)">
                                                        <i class="iconfont icon-yanjing"></i>
                                                    </span>
                                                </el-tooltip>
                                                <span class="line"></span>
                                                <el-tooltip content="下载" effect="dark" placement="top">
                                                    <span
                                                        class="handle_icon_wrap"
                                                        @click="handleClickDownloadFile(file)"
                                                    >
                                                        <i class="iconfont icon-daochu"></i>
                                                    </span>
                                                </el-tooltip>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </template>
            <template v-if="status == 3">
                <div class="page_little_title">其他信息</div>
                <template v-if="invoiceDetails.invoice_info.status == 4">
                    <el-form label-position="top" size="small">
                        <el-row :gutter="24">
                            <el-col :span="12">
                                <el-form-item label="作废时间">
                                    <div>{{ invoiceDetails.other_info.invalid_time }}</div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="24">
                            <el-col :span="12">
                                <el-form-item label="作废原因">
                                    <div class="text_bg">
                                        {{ invoiceDetails.other_info.invalid_reason }}
                                    </div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </template>
                <template v-else>
                    <el-form label-position="top" size="small">
                        <el-row :gutter="24">
                            <el-col :span="12">
                                <el-form-item label="驳回时间">
                                    <div>{{ invoiceDetails.other_info.reject_time }}</div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="24">
                            <el-col :span="12">
                                <el-form-item label="驳回原因">
                                    <div class="text_bg">
                                        {{ invoiceDetails.other_info.reject_reason }}
                                    </div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </template>
            </template>
        </div>
        <el-image
            :preview-src-list="previewImgList"
            :src="previewImgSrc"
            ref="preview_img"
            style="display: none"
        ></el-image>
    </el-dialog>
</template>
<script>
import { InvoiceDetail, InvoiceExceptionDetail ,InvoiceUpdate} from "@/api";
import { getOSSData, uploadImg } from "@/utils/uploadOss";
export default {
    name: "InvoiceDetails",
    props: {
        invoiceDetailsDialog: {
            type: Boolean,
            default: () => false,
        },
        invoice_no: {
            type: String,
            default: () => "",
        },
        status: {
            type: String,
            default: () => "",
        }, // 1:待开票,2:已开票,3:异常开票,4:未开票
    },
    data() {
        return {
            loading: false,
            invoiceDetails: {
                status: "",
                order_info: {}, // 订单信息
                invoice_info: {}, // 开票信息
                other_info: {}, // 其它信息
            },
            previewImgList: [],
            previewImgSrc: "",
            isEditRemark: false,
            isEditNumber: false,
        };
    },
    computed: {
        dialogTitle() {
            const status = this.invoiceDetails.invoice_info.status;
            if (status == 3) {
                return "驳回详情";
            } else if (status == 4) {
                return "作废详情";
            } else {
                return "开票详情";
            }
        },
    },
    created() {
        if (this.invoice_no) {
            if (this.status == 3) {
                this.getInvoiceExceptionDetail();
            } else {
                this.getInvoiceDetail();
            }
        }
    },
    methods: {
        handleDialogClose() {
            this.$emit("update:invoiceDetailsDialog", false);
        },
        // 详情
        getInvoiceDetail() {
            InvoiceDetail({ invoice_no: this.invoice_no }).then((res) => {
                if (res.code === 200) {
                    const data = res.data || {};
                    this.invoiceDetails = data;
                }
            });
        },
        // 异常开票详情
        getInvoiceExceptionDetail() {
            InvoiceExceptionDetail({ invoice_no: this.invoice_no }).then((res) => {
                if (res.code === 200) {
                    const data = res.data || {};
                    this.invoiceDetails = data;
                }
            });
        },
        //查看订单详情
        handleClickOrderDetail() {
            this.$router.push({
                name: "OrderDetail",
                params: {
                    isPush: true,
                },
                query: {
                    order_id: this.invoiceDetails.order_info.order_no,
                    name: this.invoiceDetails.order_info.order_no,
                    query_type: "order_no",
                },
            });
        },
        //附件预览事件
        handleClickPreview(file) {
            if (file.file_type.includes("image")) {
                this.previewImgList = [file.file_path];
                this.previewImgSrc = file.file_path;
                this.$refs.preview_img.showViewer = true;
            } else {
                if (file.file_type.includes("pdf")) {
                    window.open(file.file_path);
                } else {
                    this.$message.error("当前文件格式不支持预览，请下载后查看");
                }
            }
        },
        //附件下载
        handleClickDownloadFile(file) {
            getOSSData(file.file_path, file.file_name);
        },
        handleClickRowEdit(status) {
            this[status] = true
        },
        // 防抖
        debounce(func, wait) {
            let timeout;
            return function (...args) {
                const later = () => {
                    timeout = null;
                    func.apply(this, args);
                };
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
            };
        },
        handleInvoiceUpdate() {
            const params = {
                invoice_no: this.invoice_no,
                invoice_number: this.invoiceDetails.invoice_info.invoice_number,
                finance_remark: this.invoiceDetails.invoice_info.finance_remark
            }
            if(!params.invoice_no) return;
            InvoiceUpdate(params).then(res=> {
                if(res.code === 200) {
                    this.$message.success("更改成功")
                    this.isEditRemark = false;
                    this.isEditNumber = false;
                }
            })
        },
        handleBlur(row) {
            this.debounce(this.handleInvoiceUpdate, 300)(row);
        },
    },
};
</script>
<style lang="scss">
.custom_invoice_detail_dialog {
    .el-dialog__body {
        max-height: 690px;
        overflow-y: auto;
    }
    .page_little_title {
        line-height: 22px;
        color: #333333;
        font-weight: 700;
        padding-left: 8px;
        position: relative;
        margin-bottom: 16px;

        &::before {
            width: 3px;
            height: 22px;
            border-radius: 2px;
            background: #409eff;
            content: "";
            position: absolute;
            left: 0;
            top: 0;
        }
    }

    .voucher_list {
        display: flex;
        gap: 8px;

        .upload_img_wrap {
            width: 48px;
            height: 48px;
            background: #edf0f4;
            border: 1px dashed #d9d9d9;
            cursor: pointer;
            position: relative;
            text-align: center;
            line-height: 48px;
            border-radius: 4px;

            .el-icon-plus {
                color: #666666;
                font-size: 16px;
                font-weight: bold;
                cursor: pointer;
            }
        }

        .voucher_item {
            width: 48px;
            height: 48px;
            cursor: pointer;
            position: relative;
            text-align: center;
            line-height: 48px;
            border-radius: 4px;

            .el-image {
                max-width: 100%;
                max-height: 100%;
            }

            img {
                max-width: 100%;
                max-height: 100%;
                object-fit: cover;
            }

            .icon-jianqu {
                position: absolute;
                right: -8px;
                top: -8px;
                cursor: pointer;
                font-size: 16px;
                color: rgba(255, 77, 79, 1);
                line-height: 16px;
            }
        }
    }
    .el-form {
        .el-form-item__label {
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 22px;
            color: rgba(153, 153, 153, 1);
        }
        .text_bg {
            padding: 8px 12px;
            line-height: 22px;
            border-radius: 6px;
            background: rgba(237, 240, 244, 1);
        }
        .el-link {
            display: inline;
        }
    }
    .el-form {
        .el-row {
            .el-link--primary {
                display: block;
            }
        }
    }
}
</style>
